var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      staticClass: "sc-icon",
      class: { "sc-icon--outlined": !_vm.filled },
      style: {
        fontFamily: "var(--font-icon)",
        fontSize: _vm.size + "px",
        width: _vm.size + "px",
        height: _vm.size + "px",
        color: _vm.color || "inherit",
      },
      attrs: { "aria-hidden": "true" },
    },
    [_vm._v(_vm._s(_vm.name))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }